import React, { ReactElement } from 'react';

import { ICarouselContext, useCarouselContext } from '../CarouselContext';

import styles from './Pagination.styles.css';

export function Pagination (): ReactElement | null {
    const carouselContext: ICarouselContext | null = useCarouselContext();

    if (!carouselContext || !carouselContext.sliderRef) {
        return null;
    }

    const { paginationInfo }: ICarouselContext = carouselContext;

    if (!paginationInfo.shouldRenderPaginationInfo) {
        return null;
    }

    return (
        <div data-testid="slide-position">
            <div className={`flex font-gellix text-sm font-bold whitespace-no-wrap relative ${styles.paginationInfo}`}>
                <span aria-label="Current Page" data-testid="current-page">{paginationInfo.currentPage}</span>&nbsp;/&nbsp;<span aria-label="Total Pages" data-testid="total-pages">{paginationInfo.totalPages}</span>
            </div>
        </div>
    );
}
